import styled from 'styled-components';

export default styled.select`
  margin-bottom: 0;
  width: ${props => (props.width ? props.width : 'auto')};
`;
